import {
  GET_NOTIFICATIONS,
  NotificationProps,
  SET_NOTIFICATIONS,
  SEND_NOTIFICATION,
  SendProps,
  SYNC_NOTIFICATIONS,
  UPDATE_UNREAD_COUNT,
  UPDATE_READ_NOTIFICATION,
} from './types';

export const getNotifications = () => ({ type: GET_NOTIFICATIONS });

export const setNotifications = (
  notification: NotificationProps[],
  unread: number
) => ({
  type: SET_NOTIFICATIONS,
  notification,
  unread,
});

export const sendNotification = (send: SendProps, receiver?: string) => ({
  type: SEND_NOTIFICATION,
  send,
  receiver,
});

export const syncNotifications = () => ({ type: SYNC_NOTIFICATIONS });

export const updateUnreadCount = () => ({ type: UPDATE_UNREAD_COUNT });

export const updateReadNotification = (id: string) => ({
  type: UPDATE_READ_NOTIFICATION,
  id,
});
